export default __webpack_public_path__ + "static/media/Overlay-play.15ff46b3.png";